<form [formGroup]="intangibleAssetsPolicyFg">
  <div class="row" *ngIf="this.heeftImmaterieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van immateriële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.intangibleAssetsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(1)">
        {{ this.intangibleAssetsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="developmentCostsPolicyFg">
  <div class="row" *ngIf="this.heeftImmaterieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van kosten van ontwikkeling</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.developmentCostsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(2)">
        {{ this.developmentCostsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="patentsTrademarksOtherRightsPolicyFg">
  <div class="row" *ngIf="this.heeftImmaterieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van concessies, vergunningen en rechten van intellectuele eigendom</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.patentsTrademarksOtherRightsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(3)">
        {{ this.patentsTrademarksOtherRightsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="goodwillPolicyFg">
  <div class="row" *ngIf="this.heeftImmaterieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van goodwill</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.goodwillPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(4)">
        {{ this.goodwillPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="propertyPlantEquipmentPolicyFg">
  <div class="row" *ngIf="this.heeftMaterieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van materiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.propertyPlantEquipmentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(20)">
        {{ this.propertyPlantEquipmentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="impairmentAssetsNoncurrentPolicyFg">
  <div class="row"
       *ngIf="this.heeftMaterieleVasteActiva || this.heeftImmaterieleVasteActiva || this.heeftFinancieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van bijzondere waardeverminderingen van vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.impairmentAssetsNoncurrentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(21)">
        {{ this.impairmentAssetsNoncurrentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="investmentPropertiesPolicyFg">
  <div class="row" *ngIf="this.heeftVastgoedBeleggingen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van vastgoedbeleggingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.investmentPropertiesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(30)">
        {{ this.investmentPropertiesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="realEstateInDevelopmentPolicyFg">
  <div class="row" *ngIf="this.heeftVastgoedBeleggingen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van vastgoedbeleggingen in ontwikkeling</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.realEstateInDevelopmentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(31)">
        {{ this.realEstateInDevelopmentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="financialAssetsPolicyFg">
  <div class="row" *ngIf="this.heeftFinancieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van financiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.financialAssetsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(40)">
        {{ this.financialAssetsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
@if (isRechtspersoon) {
  <form [formGroup]="investmentsInParticipatingInterestsInGroupCompaniesPolicyFg">
    <div class="row" *ngIf="this.heeftFinancieleVasteActiva">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van deelnemingen in groepsmaatschappijen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.investmentsInParticipatingInterestsInGroupCompaniesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(41)">
          {{ this.investmentsInParticipatingInterestsInGroupCompaniesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
        </div>
      </ng-container>
    </div>
  </form>
}
@if (isRechtspersoon) {
  <form [formGroup]="investmentsOtherAffiliatedCompaniesPolicyFg">
    <div class="row" *ngIf="this.heeftFinancieleVasteActiva">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van deelnemingen in overige verbonden maatschappijen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.investmentsOtherAffiliatedCompaniesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(42)">
          {{ this.investmentsOtherAffiliatedCompaniesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
        </div>
      </ng-container>
    </div>
  </form>
}
@if (isRechtspersoon) {
  <form [formGroup]="receivablesGroupCompaniesPolicyFg">
    <div class="row" *ngIf="this.heeftFinancieleVasteActiva">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van vorderingen op groepsmaatschappijen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.receivablesGroupCompaniesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(43)">
          {{ this.receivablesGroupCompaniesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
        </div>
      </ng-container>
    </div>
  </form>
}
<form [formGroup]="securitiesOtherNoncurrentPolicyFg">
  <div class="row" *ngIf="this.heeftFinancieleVasteActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van langlopende overige effecten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.securitiesOtherNoncurrentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(44)">
        {{ this.securitiesOtherNoncurrentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
@if (isRechtspersoon) {
  <form [formGroup]="deferredTaxAssetsPolicyFg">
    <div class="row" *ngIf="this.heeftFinancieleVasteActiva">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van latente belastingvorderingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.deferredTaxAssetsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(45)">
          {{ this.deferredTaxAssetsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
        </div>
      </ng-container>
    </div>
  </form>
}

<form [formGroup]="inventoriesPolicyFg">
  <div class="row" *ngIf="this.heeftVoorraden">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van voorraden</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.inventoriesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(50)">
        {{ this.inventoriesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="workInProgressPolicyFg">
  <div class="row" *ngIf="this.heeftVoorraden">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van onderhanden werk</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.workInProgressPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(60)">
        {{ this.workInProgressPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="constructionContractsPolicyFg">
  <div class="row" *ngIf="this.heeftOnderhandenProjecten">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van onderhanden projecten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.constructionContractsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(70)">
        {{ this.constructionContractsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="receivablesPolicyFg">
  <div class="row" *ngIf="this.heeftVorderingen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van vorderingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.receivablesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(80)">
        {{ this.receivablesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="securitiesCurrentPolicyFg">
  <div class="row" *ngIf="this.heeftEffecten">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van kortlopende effecten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.securitiesCurrentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(90)">
        {{ this.securitiesCurrentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="cashAndCashEquivalentsPolicyFg">
  <div class="row" *ngIf="this.heeftLiquideMiddelen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van liquide middelen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.cashAndCashEquivalentsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(100)">
        {{ this.cashAndCashEquivalentsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="equityPolicyFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van eigen vermogen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.equityPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(110)">
        {{ this.equityPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="shareCapitalPaidCalledUpPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen && heeftAandelenkapitaal">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van gestort en
        opgevraagd {{ isCooperatie ? "ledenkapitaal" : "aandelenkapitaal" }}</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.shareCapitalPaidCalledUpPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(111)">
        {{ this.shareCapitalPaidCalledUpPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="sharePremiumPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen && heeftAgio">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van agio</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.sharePremiumPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(112)">
        {{ this.sharePremiumPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="revaluationReservePolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen && heeftHerwaarderingsreserve">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van herwaarderingsreserve</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.revaluationReservePolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(113)">
        {{ this.revaluationReservePolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="legalReservesPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen && heeftAndereWettelijkeReserves">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van andere wettelijke reserves, onderscheiden naar hun aard</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.legalReservesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(114)">
        {{ this.legalReservesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="statutoryReservesPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftStatutaireReserves">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van statutaire reserves</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.statutoryReservesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(115)">
        {{ this.statutoryReservesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="reinvestmentReservePolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen && heeftHerinvesteringsreserve">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van herinvesteringsreserve</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.reinvestmentReservePolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(116)">
        {{ this.reinvestmentReservePolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="reservesOtherPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftOverigeReserves">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van overige reserves</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.reservesOtherPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(117)">
        {{ this.reservesOtherPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="otherFiscalReservesPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen && heeftOverigeFiscaleReserves">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van overige fiscale reserves</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.otherFiscalReservesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(118)">
        {{ this.otherFiscalReservesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="resultForTheYearPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && !isBalansNaResultaatbestemming && heeftResultaatBoekjaar">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van resultaat na belastingen van het boekjaar</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.resultForTheYearPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(119)">
        {{ this.resultForTheYearPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="retainedEarningsPolicyFg">
  <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftNietVerdeeldeWinsten">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van niet verdeelde winsten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.retainedEarningsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(120)">
        {{ this.retainedEarningsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="provisionsPolicyFg">
  <div class="row" *ngIf="this.heeftVoorzieningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van voorzieningen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.provisionsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(130)">
        {{ this.provisionsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="provisionMajorMaintenancePolicyFg">
  <div class="row" *ngIf="this.heeftVoorzieningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van voorziening voor groot onderhoud</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.provisionMajorMaintenancePolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(131)">
        {{ this.provisionMajorMaintenancePolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="provisionRestructuringPolicyFg">
  <div class="row" *ngIf="this.heeftVoorzieningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van voorziening in verband met reorganisaties</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.provisionRestructuringPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(132)">
        {{ this.provisionRestructuringPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="deferredTaxLiabilitiesPolicyFg">
  <div class="row" *ngIf="this.heeftVoorzieningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van latente belastingverplichtingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.deferredTaxLiabilitiesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(133)">
        {{ this.deferredTaxLiabilitiesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="provisionWarrantyPolicyFg">
  <div class="row" *ngIf="this.heeftVoorzieningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van garantievoorziening</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.provisionWarrantyPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(134)">
        {{ this.provisionWarrantyPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="liabilitiesNoncurrentPolicyFg">
  <div class="row" *ngIf="this.heeftLanglopendeSchulden">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van langlopende schulden</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.liabilitiesNoncurrentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(140)">
        {{ this.liabilitiesNoncurrentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="oldAgeObligationPolicyFg">
  <div class="row" *ngIf="this.heeftLanglopendeSchulden">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van oudedagsverplichting</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.oldAgeObligationPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(141)">
        {{ this.oldAgeObligationPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="negativeGoodwillPolicyFg">
  <div class="row" *ngIf="this.heeftLanglopendeSchulden">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van negatieve goodwill</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.negativeGoodwillPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(142)">
        {{ this.negativeGoodwillPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="liabilitiesCurrentPolicyFg">
  <div class="row" *ngIf="this.heeftKortlopendeSchulden">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van kortlopende schulden</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.liabilitiesCurrentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(150)">
        {{ this.liabilitiesCurrentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<!--</ng-container>-->
<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.intangibleAssetsPolicyFg"
                                                                     [policyId]="'intangibleAssetsPolicy'"
                                                                     [title]="'Grondslag van immateriële vaste activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.developmentCostsPolicyFg"
                                                                     [policyId]="'developmentCostsPolicy'"
                                                                     [title]="'Grondslag van kosten van ontwikkeling'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.patentsTrademarksOtherRightsPolicyFg"
                                                                     [policyId]="'patentsTrademarksOtherRightsPolicy'"
                                                                     [title]="'Grondslag van concessies, vergunningen en rechten van intellectuele eigendom'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.goodwillPolicyFg"
                                                                     [policyId]="'goodwillPolicy'"
                                                                     [title]="'Grondslag van goodwill'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 20">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.propertyPlantEquipmentPolicyFg"
                                                                     [policyId]="'propertyPlantEquipmentPolicy'"
                                                                     [title]="'Grondslag van materiële vaste activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 21">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.impairmentAssetsNoncurrentPolicyFg"
                                                                     [policyId]="'impairmentAssetsNoncurrentPolicy'"
                                                                     [title]="'Grondslag van bijzondere waardeverminderingen van vaste activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 30">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.investmentPropertiesPolicyFg"
                                                                     [policyId]="'investmentPropertiesPolicy'"
                                                                     [title]="'Grondslag van vastgoedbeleggingen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 31">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.realEstateInDevelopmentPolicyFg"
                                                                     [policyId]="'realEstateInDevelopmentPolicy'"
                                                                     [title]="'Grondslag van vastgoedbeleggingen in ontwikkeling'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 40">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.financialAssetsPolicyFg"
                                                                     [policyId]="'financialAssetsPolicy'"
                                                                     [title]="'Grondslag van financiële vaste activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 41">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.investmentsInParticipatingInterestsInGroupCompaniesPolicyFg"
                                                                     [policyId]="'investmentsInParticipatingInterestsInGroupCompaniesPolicy'"
                                                                     [title]="'Grondslag van deelnemingen in groepsmaatschappijen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 42">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.investmentsOtherAffiliatedCompaniesPolicyFg"
                                                                     [policyId]="'investmentsOtherAffiliatedCompaniesPolicy'"
                                                                     [title]="'Grondslag van deelnemingen in overige verbonden maatschappijen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 43">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.receivablesGroupCompaniesPolicyFg"
                                                                     [policyId]="'receivablesGroupCompaniesPolicy'"
                                                                     [title]="'Grondslag van vorderingen op groepsmaatschappijen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 44">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.securitiesOtherNoncurrentPolicyFg"
                                                                     [policyId]="'securitiesOtherNoncurrentPolicy'"
                                                                     [title]="'Grondslag van langlopende overige effecten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 45">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.deferredTaxAssetsPolicyFg"
                                                                     [policyId]="'deferredTaxAssetsPolicy'"
                                                                     [title]="'Grondslag van financiële vaste activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

<div *ngIf="this.index === 50">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.inventoriesPolicyFg"
                                                                     [policyId]="'inventoriesPolicy'"
                                                                     [title]="'Grondslag van voorraden'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 60">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.workInProgressPolicyFg"
                                                                     [policyId]="'workInProgressPolicy'"
                                                                     [title]="'Grondslag van onderhanden werk'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 70">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.constructionContractsPolicyFg"
                                                                     [policyId]="'constructionContractsPolicy'"
                                                                     [title]="'Grondslag van onderhanden projecten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 80">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.receivablesPolicyFg"
                                                                     [policyId]="'receivablesPolicy'"
                                                                     [title]="'Grondslag van vorderingen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 90">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.securitiesCurrentPolicyFg"
                                                                     [policyId]="'securitiesCurrentPolicy'"
                                                                     [title]="'Grondslag van kortlopende effecten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 100">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.cashAndCashEquivalentsPolicyFg"
                                                                     [policyId]="'cashAndCashEquivalentsPolicy'"
                                                                     [title]="'Grondslag van liquide middelen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

<div *ngIf="this.index === 110">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.equityPolicyFg"
                                                                     [policyId]="'equityPolicy'"
                                                                     [title]="'Grondslag van eigen vermogen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 111">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.shareCapitalPaidCalledUpPolicyFg"
                                                                     [policyId]="'shareCapitalPaidCalledUpPolicy'"
                                                                     [title]="`Grondslag van gestort en opgevraagd ${isCooperatie ? 'ledenkapitaal' : 'aandelenkapitaal'}`"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 112">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.sharePremiumPolicyFg"
                                                                     [policyId]="'sharePremiumPolicy'"
                                                                     [title]="'Grondslag van agio'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 113">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.revaluationReservePolicyFg"
                                                                     [policyId]="'revaluationReservePolicy'"
                                                                     [title]="'Grondslag van herwaarderingsreserve'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 114">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.legalReservesPolicyFg"
                                                                     [policyId]="'legalReservesPolicy'"
                                                                     [title]="'Grondslag van andere wettelijke reserves, onderscheiden naar hun aard'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 115">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.statutoryReservesPolicyFg"
                                                                     [policyId]="'statutoryReservesPolicy'"
                                                                     [title]="'Grondslag van statutaire reserves'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 116">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.reinvestmentReservePolicyFg"
                                                                     [policyId]="'reinvestmentReservePolicy'"
                                                                     [title]="'Grondslag van herinvesteringsreserve'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 117">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.reservesOtherPolicyFg"
                                                                     [policyId]="'reservesOtherPolicy'"
                                                                     [title]="'Grondslag van overige reserves'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 118">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.otherFiscalReservesPolicyFg"
                                                                     [policyId]="'otherFiscalReservesPolicy'"
                                                                     [title]="'Grondslag van overige fiscale reserves'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 119">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.resultForTheYearPolicyFg"
                                                                     [policyId]="'resultForTheYearPolicy'"
                                                                     [title]="'Grondslag van resultaat na belastingen van het boekjaar'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 120">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.retainedEarningsPolicyFg"
                                                                     [policyId]="'retainedEarningsPolicy'"
                                                                     [title]="'Grondslag van niet verdeelde winsten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

<div *ngIf="this.index === 130">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.provisionsPolicyFg"
                                                                     [policyId]="'provisionsPolicy'"
                                                                     [title]="'Grondslag van voorzieningen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 131">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.provisionMajorMaintenancePolicyFg"
                                                                     [policyId]="'provisionMajorMaintenancePolicy'"
                                                                     [title]="'Grondslag van voorziening voor groot onderhoud'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 132">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.provisionRestructuringPolicyFg"
                                                                     [policyId]="'provisionRestructuringPolicy'"
                                                                     [title]="'Grondslag van voorziening in verband met reorganisaties'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 133">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.deferredTaxLiabilitiesPolicyFg"
                                                                     [policyId]="'deferredTaxLiabilitiesPolicy'"
                                                                     [title]="'Grondslag van latente belastingverplichtingen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 134">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.provisionWarrantyPolicyFg"
                                                                     [policyId]="'provisionWarrantyPolicy'"
                                                                     [title]="'Grondslag van garantievoorziening'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

<div *ngIf="this.index === 140">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.liabilitiesNoncurrentPolicyFg"
                                                                     [policyId]="'liabilitiesNoncurrentPolicy'"
                                                                     [title]="'Grondslag van langlopende schulden'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 141">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.oldAgeObligationPolicyFg"
                                                                     [policyId]="'oldAgeObligationPolicy'"
                                                                     [title]="'Grondslag van oudedagsverplichting'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 142">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.negativeGoodwillPolicyFg"
                                                                     [policyId]="'negativeGoodwillPolicy'"
                                                                     [title]="'Grondslag van negatieve goodwill'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

<div *ngIf="this.index === 150">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.liabilitiesCurrentPolicyFg"
                                                                     [policyId]="'liabilitiesCurrentPolicy'"
                                                                     [title]="'Grondslag van kortlopende schulden'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

